import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  OrganizationPayloadSchema,
  organizationPayloadSchema,
  useOrganization,
} from "@/api/organization";
import { Loading } from "@/components/ui/loading";
import { OrganizationFormFields } from "./OrganizationFormFields";
import { FormContainer } from "@/components/form/form-container";
import { Anchor } from "@/components/ui/anchor";

export function OrganizationDetailForm({ id }: { id: string }) {
  const {
    data: organization,
    isPending: isLoadingData,
    isError,
  } = useOrganization({
    id,
  });
  const form = useForm<OrganizationPayloadSchema>({
    resolver: zodResolver(organizationPayloadSchema),
    defaultValues: {
      companyCode: organization?.companyCode,
      companyName: organization?.companyName,
      department: organization?.department,
      noTelp: organization?.noTelp,
      email: organization?.email,
      address: organization?.address,
    },
    values: organization,
  });

  if (isLoadingData) {
    return <Loading />;
  }

  if (!organization) {
    return <div>Organization not found</div>;
  }

  if (isError) {
    return <div>Failed to load organization</div>;
  }

  return (
    <FormContainer form={form}>
      <OrganizationFormFields isDisabled />
      <div className="ml-auto">
        <Anchor href="/master-data/organization" mood="axiata-blue">
          Back
        </Anchor>
      </div>
    </FormContainer>
  );
}
